import { useExperimentFlag } from './useExperimentFlag';

export const useExperimentMerchantDeliveryMultipleSlots = (): boolean =>
    useExperimentFlag('enable_merchant_delivery_multiple_slots');
